<template>
    <div>
        <div class="flex flex-wrap py-4 border-b relative">
            <div class="w-full p-2 md:w-1/6 md:pr-2" data-cy="module-filter" v-if="isEpicvaultEnabled">
                <ui-select v-model="current_view_option" :options="viewOptions" />
            </div>
            <div class="w-full p-2 md:w-1/6 md:pr-2" data-cy="view-mode-filter" v-if="showFilter">
                <ui-select v-model="current_view_mode" :options="viewModeOptions" />
            </div>
            <div class="w-full p-2 md:w-1/6 md:pr-2" data-cy="dashboard-filter">
                <ui-select v-model="filter_params.current_filter" :options="filter_options" />
            </div>
            <div class="w-full p-2 md:w-2/6" data-cy="date-filter">
                <ui-date-range-picker-double
                    v-model="filter_params.date_ranges"
                    :disabled="isFilterDateRangesDisabled"
                    :allowClear="false"
                />
            </div>
            <div class="w-1/3 float-right p-2 absolute right-0 md:w-1/6 md:pl-2">
                <ui-label>{{ $t('dashboard.active_connection') }} {{ total_sessions }}</ui-label>
            </div>

            <iframe
                v-if="current_view_mode == 'advanced' && currentView == 'claim'"
                :src="claimsvaultAnalyticsUrl"
                width="100%"
                height="1000"
                frameborder="0"
            ></iframe>

            <iframe
                v-if="current_view_mode == 'advanced' && currentView == 'cover'"
                :src="covervaultAnalyticsUrl"
                width="100%"
                height="1000"
                frameborder="0"
            ></iframe>
        </div>
        <ClaimGraphs
            v-if="currentView == 'claim' && current_view_mode == 'basic'"
            :filter_params="filter_params"
            @viewMoreInfo="handleViewMore"
        />
        <CoverGraphs
            v-if="currentView == 'cover' && current_view_mode === 'basic'"
            :filter_params="filter_params"
            @viewMoreInfo="handleViewMore"
        />

        <div class="flex flex-wrap" v-if="currentView == 'none'">
            <div class="w-full mt-12 mb-24 text-center">
                {{ $t('dashboard.no_graphs') }}
            </div>
        </div>

        <a-drawer
            data-cy="graph-drawer"
            :title="current_drawer_title"
            :width="500"
            :open="drawer_visible"
            :body-style="{ padding: '0px', paddingBottom: '10px' }"
            :destroyOnClose="true"
            :maskClosable="false"
            :rootClassName="'epic-' + moduleStateLink"
            @close="onClose"
        >
            <div class="p-4">
                <graph-bar-horizontal
                    :chart_id="drawer_chart_id"
                    :dataset_endpoint="drawer_dataset_endpoint"
                    :filter_params="filter_params"
                    :filter_limit="drawer_filter_limit"
                    :default_sub_filter="drawer_sub_filter"
                    :sub_filter_options="drawer_filter_options"
                    :graph_height="600"
                />
            </div>
            <template #footer>
                <div class="flex pt-2 w-full justify-end">
                    <a-button data-cy="drawer-close-button" @click="onClose" class="ant-btn mr-2">
                        {{ $t('globals.buttons.close') }}
                    </a-button>
                </div>
            </template>
        </a-drawer>
    </div>
</template>

<script>
import ClaimGraphs from '@/components/dashboard/ClaimGraphs.vue';
import CoverGraphs from '@/components/dashboard/CoverGraphs.vue';
import GraphBarHorizontal from '@/components/graphs/BarHorizontal.vue';
import UiDateRangePickerDouble from '@/components/ui/DateRangePickerDouble.vue';
import UiSelect from '@/components/ui/Select.vue';
import UiLabel from '@/components/ui/Label.vue';

export default {
    components: {
        ClaimGraphs,
        CoverGraphs,
        GraphBarHorizontal,
        UiDateRangePickerDouble,
        UiSelect,
        UiLabel,
    },
    computed: {
        currentView() {
            if (this.isEpicvaultEnabled) {
                if (this.current_view_option == 'ClaimsVAULT' && this.isClaimsVaultEnabled) {
                    return 'claim';
                } else if (this.current_view_option == 'CoverVAULT' && this.isCoverVaultEnabled) {
                    return 'cover';
                } else {
                    return 'none';
                }
            } else {
                return 'claim';
            }
        },
        viewOptions() {
            let options = [];

            if (this.isClaimsVaultEnabled) {
                options.push({
                    value: 'ClaimsVAULT',
                    text: 'ClaimsVAULT',
                });
            }

            if (this.isCoverVaultEnabled) {
                options.push({
                    value: 'CoverVAULT',
                    text: 'CoverVAULT',
                });
            }

            return options;
        },
        viewModeOptions() {
            return [
                {
                    value: 'basic',
                    text: 'Basic',
                },
                {
                    value: 'advanced',
                    text: 'Advanced',
                },
            ];
        },
        isEpicvaultEnabled() {
            return this.$store.state.system.is_epicvault_enabled ? true : false;
        },
        moduleStateLink() {
            return this.$store.state.system.is_epicvault_enabled ? 'default' : 'claim';
        },
        isClaimsVaultEnabled() {
            return this.$store.state.user.modules.claimsvault;
        },
        isCoverVaultEnabled() {
            return this.$store.state.user.modules.covervault;
        },
        isFilterDateRangesDisabled() {
            return this.filter_params.current_filter !== 'custom';
        },
        currentAssociationId() {
            return this.$store.getters['user/currentAssociationId'];
        },
        showFilter() {
            if (this.isEpicvaultEnabled) {
                if (this.current_view_option == 'ClaimsVAULT') {
                    return (
                        !(
                            this.$store.state.user.claimsvault_analytics_url == null ||
                            this.$store.state.user.claimsvault_analytics_url == ''
                        ) && this.$store.state.user.enable_advanced_claims_analytics
                    );
                } else if (this.current_view_option == 'CoverVAULT') {
                    return (
                        !(
                            this.$store.state.user.covervault_analytics_url == null ||
                            this.$store.state.user.covervault_analytics_url == ''
                        ) && this.$store.state.user.enable_advanced_cover_analytics
                    );
                }
            } else {
                return (
                    !(
                        this.$store.state.user.claimsvault_analytics_url == null ||
                        this.$store.state.user.claimsvault_analytics_url == ''
                    ) && this.$store.state.user.enable_advanced_claims_analytics
                );
            }
        },
        claimsvaultAnalyticsUrl() {
            const url = this.$store.state.user.claimsvault_analytics_url;
            const url_with_filters = this.appendFiltersToUrl(url);
            return url_with_filters;
        },
        covervaultAnalyticsUrl() {
            const url = this.$store.state.user.covervault_analytics_url;
            const url_with_filters = this.appendFiltersToUrl(url);
            return url_with_filters;
        },
    },
    data() {
        return {
            total_sessions: 0,
            current_view_option: '',
            filter_params: {
                current_filter: 'current_year',
                date_ranges: {
                    start_date: this.$dayjs().startOf('year'),
                    end_date: this.$dayjs().endOf('year'),
                },
            },
            filter_options: [
                {
                    value: 'current_month',
                    text: this.$t('dashboard.filter_options.current_month'),
                },
                {
                    value: 'last_30_days',
                    text: this.$t('dashboard.filter_options.last_30_days'),
                },
                {
                    value: 'current_quarter',
                    text: this.$t('dashboard.filter_options.current_quarter'),
                },
                {
                    value: 'last_3_months',
                    text: this.$t('dashboard.filter_options.last_3_months'),
                },
                {
                    value: 'current_year',
                    text: this.$t('dashboard.filter_options.current_year'),
                },
                {
                    value: 'last_12_months',
                    text: this.$t('dashboard.filter_options.last_12_months'),
                },
                {
                    value: 'custom',
                    text: this.$t('dashboard.filter_options.custom'),
                },
            ],
            current_drawer_title: '',
            drawer_visible: false,
            drawer_chart_id: '',
            drawer_dataset_endpoint: '',
            drawer_filter_limit: 0,
            drawer_sub_filter: '',
            drawer_filter_options: [],
            current_view_mode: 'basic',
            period: 'Current Year',
        };
    },
    mounted() {
        this.sessionTotal();
        if (
            ['claimsvault', 'claimsvault_dashboard'].includes(this.$store.state.user.default_landing_page) &&
            this.isClaimsVaultEnabled
        ) {
            this.current_view_option = 'ClaimsVAULT';
        } else if (
            ['covervault', 'covervault_dashboard'].includes(this.$store.state.user.default_landing_page) &&
            this.isCoverVaultEnabled
        ) {
            this.current_view_option = 'CoverVAULT';
        } else {
            this.current_view_option = '';
        }
    },
    watch: {
        'filter_params.current_filter': {
            immediate: true,
            handler() {
                this.updateDateRange();
            },
        },
    },
    methods: {
        updateDateRange() {
            switch (this.filter_params.current_filter) {
                case 'current_month':
                    this.filter_params.date_ranges.start_date = this.$dayjs().startOf('month');
                    this.filter_params.date_ranges.end_date = this.$dayjs().endOf('month');
                    this.period = 'Current Month';
                    break;
                case 'last_30_days':
                    this.filter_params.date_ranges.start_date = this.$dayjs().subtract(30, 'd');
                    this.filter_params.date_ranges.end_date = this.$dayjs();
                    this.period = 'Last 30 Days';
                    break;
                case 'current_quarter':
                    this.filter_params.date_ranges.start_date = this.$dayjs()
                        .quarter(this.$dayjs().quarter())
                        .startOf('quarter');
                    this.filter_params.date_ranges.end_date = this.$dayjs()
                        .quarter(this.$dayjs().quarter())
                        .endOf('quarter');
                    this.period = 'Current Quarter';
                    break;
                case 'last_3_months':
                    this.filter_params.date_ranges.start_date = this.$dayjs().subtract(3, 'M');
                    this.filter_params.date_ranges.end_date = this.$dayjs();
                    this.period = 'Last 3 Months';
                    break;
                case 'current_year':
                    this.filter_params.date_ranges.start_date = this.$dayjs().startOf('year');
                    this.filter_params.date_ranges.end_date = this.$dayjs().endOf('year');
                    this.period = 'Current Year';
                    break;
                case 'last_12_months':
                    this.filter_params.date_ranges.start_date = this.$dayjs().subtract(12, 'M');
                    this.filter_params.date_ranges.end_date = this.$dayjs();
                    this.period = 'Last 12 Months';
                    break;
                case 'custom':
                    this.filter_params.date_ranges.start_date = null;
                    this.filter_params.date_ranges.end_date = null;
                    this.period = 'Custom';
                    break;
            }
        },
        handleViewMore(data) {
            let title_string = 'dashboard.graph_title.' + data.type;

            this.drawer_chart_id = data.type;
            this.current_drawer_title = this.$t(title_string);
            this.drawer_dataset_endpoint = data.dataset_endpoint;
            this.drawer_filter_limit = data.limit;
            this.drawer_filter_options = data.sub_filter_options;
            this.drawer_sub_filter = data.sub_filter;
            this.drawer_visible = true;
        },
        onClose() {
            this.drawer_visible = false;
        },
        sessionTotal() {
            this.$http
                .get('/api/active-sessions-total/' + this.currentAssociationId)
                .then((response) => {
                    this.total_sessions = response.data.meta.total_count;
                })
                .catch((error) => {
                    if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVGBH02' }),
                        });
                    }
                });
        },
        appendFiltersToUrl(url) {
            const filters_query_string = this.getFiltersQueryString();
            return url + filters_query_string;
        },
        getFiltersQueryString() {
            const association_id = this.currentAssociationId;
            const start = this.filter_params.date_ranges.start_date;
            const end = this.filter_params.date_ranges.end_date;
            const selected_period = this.period;

            const is_valid_start_date = start && start.isValid();
            const is_valid_end_date = end && end.isValid();

            if (!is_valid_start_date || !is_valid_end_date) {
                return `&association_id=${association_id}`;
            }

            const formatted_start_date = start.format('YYYY-MM-DD');
            const formatted_end_date = end.format('YYYY-MM-DD');

            const date_ranges_query_string = `&association_id=${association_id}&start_date=${formatted_start_date}&end_date=${formatted_end_date}&period=${selected_period}`;

            return date_ranges_query_string;
        },
    },
};
</script>
